import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
// 按 id 分桶跟踪当前 confirm 实例。同 id 调用 openConfirm 时自动关闭前一个，
// 避免重复弹出（如 401 触发多次时只保留最新的）。
const activeById = new Map();
// 没传 id 的实例共享一个 bucket
const ANON_KEY = '__anonymous__';
export function openConfirm(options) {
  const {
    id,
    style,
    ...rest
  } = options;
  const key = id ?? ANON_KEY;

  // 同 id 已开过 → 不重复打开
  if (activeById.has(key)) {
    return activeById.get(key);
  }
  const handleCancel = () => {
    if (activeById.get(key) === current) {
      activeById.delete(key);
    }
    rest.onCancel?.();
  };
  const handleOk = async () => {
    try {
      await rest.onOk?.();
    } finally {
      if (activeById.get(key) === current) {
        activeById.delete(key);
      }
    }
  };
  const current = _Modal.confirm({
    className: 'lx-confirm-modal',
    alignCenter: false,
    style: {
      top: 100,
      ...style
    },
    ...rest,
    onOk: handleOk,
    onCancel: handleCancel
  });
  activeById.set(key, current);
  return current;
}